"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _radium = _interopRequireDefault(require("radium"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var style = {
  margin: '0',
  // Remove the margin in Firefox and Safari
  fontFamily: 'inherit',
  lineHeight: 'inherit',
  textTransform: 'none',
  fontSize: '14pt',
  width: '15rem'
};

var ImpactDropdown = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ImpactDropdown, _React$PureComponent);

  var _super = _createSuper(ImpactDropdown);

  function ImpactDropdown() {
    (0, _classCallCheck2.default)(this, ImpactDropdown);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ImpactDropdown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          defaultLabel = _this$props.defaultLabel,
          onChange = _this$props.onChange;
      var label = defaultLabel || 'Select...';
      return /*#__PURE__*/_react.default.createElement("select", {
        style: style,
        onChange: onChange,
        defaultValue: 'impact-disabled'
      }, /*#__PURE__*/_react.default.createElement("option", {
        disabled: true,
        value: 'impact-disabled'
      }, label), this.props.options.map(function (t) {
        return /*#__PURE__*/_react.default.createElement("option", {
          key: t.value,
          value: t.value
        }, t.display);
      }));
    }
  }]);
  return ImpactDropdown;
}(_react.default.PureComponent);

ImpactDropdown.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    display: _propTypes.default.string.isRequired
  })),
  defaultLabel: _propTypes.default.string,
  onChange: _propTypes.default.func,
  selected: _propTypes.default.string
};

var _default = (0, _radium.default)(ImpactDropdown);

exports.default = _default;